import type { CaptchaLoginForm, PcAccountLoginForm, Session } from "@supplier/entity";
import { BaseService } from "@/api/services/baseService";
import { customerHttp } from "@/api";
import { Login } from "@/entity/login.ts";

export class CustomerLoginService extends BaseService<Login, PcAccountLoginForm, Login, Login> {
    /**
     * 账号登录
     */
    public async accountLogin(params: PcAccountLoginForm): Promise<Session> {
        const { data } = await this.service.post(`${this.path}/pc/account`, params);
        return data;
    }
    /**
     * 验证码登录
     */
    public async login(params: CaptchaLoginForm) {
        const { data } = await this.service.post(`${this.path}/pc`, params);
        return data;
    }
}

export const customerLoginService = new CustomerLoginService("/login", customerHttp.service);
